export default __webpack_public_path__ + "static/media/flippers.1a1609fa.png";